import type { IconProps } from '../types/IconProps.ts';
export const MailCheck: IconProps = {
    name: 'MailCheck',
    children: [
        `<path d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7M15 19l2.99 2 .02-.01L22 17" />`,
        `<path d="m2 8 9.1 4.55a2 2 0 0 0 1.8 0L22 8" />`,
    ]
};